import(/* webpackMode: "eager" */ "/Users/gopal/BlindsCode/blindscommerce/app/forgot-password/page.tsx");
